import React, { useEffect, useState } from "react";
import styled from "styled-components";

const EventBar = ({start,end,level,videoLength})=>{

    const [backColor, setBackColor] = useState();

    useEffect(()=>{
        if(level==='cheat')
            setBackColor('#C83B38');
        else
            setBackColor('#FFBC00');
    },[level])

    return (
        <StEventBar start={start} end={end} videoLength={videoLength} backColor={backColor}>
            <div className='event'/>
        </StEventBar>
    )
}

const StEventBar = styled.div`
    position : absolute;
    left : calc( ${props=>props.start} * 100% / ${props=>props.videoLength} );
    background-color: ${props=>props.backColor};
    width : calc( 100% / ${props=>props.videoLength} * ( ${props=>props.end} - ${props=>props.start} ) );
    height : 15px;
`;

export default EventBar